module.exports = __webpack_public_path__ + "img/emoji_shenshetou.69933444.png";